document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.fits-mobile-facet-bar').forEach((bar) => {
    const details = bar.querySelector('.mobile-facets__disclosure');
    const summary = details?.querySelector(':scope > summary');
    const sortTrigger = bar.querySelector('.fits-mobile-sort-trigger');

    if (!details || !summary || !sortTrigger) return;

    const heading = details.querySelector('.mobile-facets__heading.medium-hide');
    const filterLabel = summary.querySelector('.mobile-facets__open-label')?.textContent.trim() || 'Filter';
    const sortLabel = sortTrigger.textContent.trim() || 'Sort';

    const setHeading = (label) => {
      if (heading) heading.textContent = label;
    };

    summary.addEventListener('click', () => {
      if (!details.open) {
        details.classList.remove('fits-sort-mode');
        setHeading(filterLabel);
      }
    });

    sortTrigger.addEventListener('click', () => {
      details.classList.add('fits-sort-mode');
      setHeading(sortLabel);

      if (!details.open) summary.click();
    });

    details.addEventListener('toggle', () => {
      if (!details.open) details.classList.remove('fits-sort-mode');
    });
  });
});
